import { Shuffle } from "lucide-react";

interface RemixAvatarStackProps {
  remixers: unknown[];
  totalCount: number;
  onClick: () => void;
}

function formatCount(n: number): string {
  if (n >= 10000) return `${Math.round(n / 1000)}K`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toString();
}

export function RemixAvatarStack({ totalCount, onClick }: RemixAvatarStackProps) {
  if (totalCount === 0) return null;

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
      title={`${totalCount} remix${totalCount !== 1 ? 'es' : ''}`}
    >
      <Shuffle className="h-3.5 w-3.5" />
      <span className="font-medium">{formatCount(totalCount)}</span>
    </button>
  );
}
